import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import MaterialTable from "material-table";
import { useAsync } from "../../../hooks";
import adminService from "../../../services/adminService";
import { confirmBox } from "../../common/PopupBox/PopupBox";
import CONFIG_CONSTANTS from "./../../../constants/apiList";
import Axios from "axios";

export default function EditableDataTable3({
  title,
  url,
  reqBody,
  cols,
  urlPost
}) {
  const dispatch = useDispatch();
  const [fetchedData] = useAsync(url, reqBody);
  return fetchedData ? (
    <MaterialTable
      title={title}
      columns={cols}
      data={fetchedData}
      options={{
        exportButton: true,
        exportAllData: true,
        pageSize: 10,
        headerStyle: {
          backgroundColor: "#003459",
          color: "#FFF"
        },
        filtering: true
      }}
      editable={{
        onRowAdd: async newData => {
          if (title === "Doctor OOC") {
            confirmBox(
              `You are about to put a doctor into OOC, do you wish to Continue?`,
              () => {
                return new Promise((resolve, reject) => {
                  setTimeout(() => {
                    adminService.sendData(urlPost, {
                      type: "add",
                      data: newData,
                      autoReassign: reqBody.auto_reassign
                    });
                    setTimeout(
                      () =>
                        dispatch({
                          type: "REFRESH"
                        }),
                      3000
                    );
                    resolve();
                  }, 1);
                });
              }
            );
          }
        },
        onRowUpdate: async (newData, oldData) => {
          if (title === "Doctor OOC") {
            confirmBox(
              `You are about to edit a doctors current OOC Settings, do you wish to Continue?`,
              () => {
                return new Promise((resolve, reject) => {
                  setTimeout(() => {
                    adminService.sendData(urlPost, {
                      id: oldData.id,
                      type: "update",
                      data: newData,
                      autoReassign: reqBody.auto_reassign
                    });
                    setTimeout(
                      () =>
                        dispatch({
                          type: "REFRESH"
                        }),
                      3000
                    );
                    resolve();
                  }, 1);
                });
              }
            );
          } else {
            return new Promise((resolve, reject) => {
              setTimeout(() => {
                adminService.sendData(urlPost, {
                  id: oldData.id,
                  type: "update",
                  data: newData,
                  autoReassign: reqBody.auto_reassign
                });
                setTimeout(
                  () =>
                    dispatch({
                      type: "REFRESH"
                    }),
                  3000
                );
                resolve();
              }, 1);
            });
          }
        },
        onRowDelete: oldData => {
          const newId =
            title === "Doctor Hours" ? oldData.uniqueId : oldData.id;
          return new Promise((resolve, reject) => {
            setTimeout(() => {
              adminService.sendData(urlPost, {
                id: newId,
                type: "delete",
                data: oldData
              });
              setTimeout(
                () =>
                  dispatch({
                    type: "REFRESH"
                  }),
                3000
              );
              resolve();
            }, 1);
          });
        }
      }}
      style={{ border: "1px solid black" }}
    />
  ) : null;
}
